import React from "react";
import {Picker} from "../Utils/Picker";


export default function ServicePackPicker({value, options, onChange, disabled, blank, editable, setEditable, inlineEdit, className, label, additionalOptions=[]}){

    return (
        <Picker
            name={"service_pack_fk"}
            optionField={"pack_number"}
            value={value}
            options={options}
            onChange={onChange}
            disabled={disabled}
            blank={blank}
            editable={editable}
            setEditable={setEditable}
            inlineEdit={inlineEdit}
            className={className}
            label={label}
            additionalOptions={additionalOptions}
        />
    )
}